export default __webpack_public_path__ + "static/media/p12.b9fcff9e.jpg";